// extracted by mini-css-extract-plugin
module.exports = {"companyName__jobDetailStatus":"companyName__jobDetailStatus"};